import axios from "axios";

// for more information please check this page : https://axios-http.com/docs/interceptors

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      if (config.url.includes("amazonaws")) {        
        config.headers["Content-Type"] ="application/json";
      }
      config.headers["authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error).then((r) => console.log(r));
  }
);

// axios.interceptors.response.use(function (response) {
//   return response;
// }, function (error) {
//   if (error?.response?.status && error?.response?.status === 403) {
//     localStorage.removeItem('token')
//     localStorage.removeItem('settings')
//     window.location.href = "/login"
//   }

//   return Promise.reject(error);
// });
